<template>
  <div class="verify-container">
    <form class="verify-card">
      <h1 class="verify-title">Verify OTP</h1>
      <p class="verify-sub">
        We sent a 6-digit code to <strong>{{ email }}</strong>.
      </p>

      <label class="verify-label">Enter Code</label>
      <input
        v-model.trim="code"
        maxlength="6"
        inputmode="numeric"
        pattern="[0-9]*"
        required
        class="verify-input"
        placeholder="••••••"
        @keypress="digitsOnly"
      />

      <p v-if="error" class="verify-error">{{ error }}</p>

      <!-- switched from @submit to explicit click so we KNOW the handler fires -->
      <button type="button" :disabled="loading" class="verify-button" @click="onSubmit">
        <span v-if="!loading">Verify</span>
        <span v-else>Verifying…</span>
      </button>

      <router-link class="verify-link" to="/login">Back to login</router-link>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VerifyOtpPage',
  data() {
    return {
      code: '',
      loading: false,
      error: null,
    }
  },
  computed: {
    email() {
      return this.$route.query.email || ''
    },
  },
  created() {
    console.log('[VerifyOtp] mounted v1.1, email:', this.email)
  },
  methods: {
    digitsOnly(e) {
      if (!/[0-9]/.test(e.key)) e.preventDefault()
    },
    async onSubmit() {
      console.log('[VerifyOtp] onSubmit() fired, code:', this.code)
      this.error = null

      if (!/^\d{6}$/.test(this.code)) {
        this.error = 'OTP must be 6 digits.'
        console.warn('[VerifyOtp] validation fail: bad code')
        return
      }
      if (!this.email) {
        this.error = 'Missing email for verification.'
        console.warn('[VerifyOtp] validation fail: missing email')
        return
      }

      this.loading = true
      try {
        const { data } = await axios.post('/auth/verify-otp', {
          email: this.email,
          code: this.code,
        })

        console.log('[VerifyOtp] OTP OK, payload:', data)

        // Store tokens (align with whatever your guard expects)
        localStorage.setItem('access_token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
        localStorage.setItem('token', data.access_token) // compat if guard uses 'token'
        axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

        // Fetch roles/perms for route guard
        const me = await axios.get('/auth/me', {
        headers: { Authorization: `Bearer ${data.access_token}` }
        });
        localStorage.setItem('perms', JSON.stringify(me.data.perms || []));
        localStorage.setItem('roles', JSON.stringify(me.data.roles || []));

        if (data?.user?.must_change_pwd === true) {
          console.log('[VerifyOtp] must_change_pwd=true → redirecting to /change')
          this.$router.replace({ path: '/change', query: { mustChange: '1' } })
          return
        }

        console.log('[VerifyOtp] redirecting to /dashboard')
        this.$router.replace('/dashboard')
      } catch (e) {
        const msg = e?.response?.data?.error || e?.message || 'Verification failed.'
        console.error('[VerifyOtp] error:', msg)
        this.error = msg
      } finally {
        this.loading = false
      }
    },
  },
}
</script>


<style scoped>
/* Matches your dark background + serif motif */
.verify-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b0101;
  padding: 24px;
  box-sizing: border-box;
}
.verify-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: left;
  font-family: Garamond, serif;
  color: #2c3e50;
}
.verify-title {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
}
.verify-sub {
  margin: 0 0 16px 0;
  color: #2c3e50;
  font-size: 14px;
}
.verify-label {
  display: block;
  font-size: 14px;
  margin: 10px 0 6px 0;
}
.verify-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 20px;
  letter-spacing: 6px;
  text-align: center;
  outline: none;
  box-sizing: border-box;
}
.verify-input:focus {
  border-color: #2c3e50;
}
.verify-error {
  color: #b00020;
  font-size: 14px;
  margin-top: 10px;
}
.verify-button {
  width: 100%;
  margin-top: 16px;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: #000000;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}
.verify-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.verify-link {
  display: block;
  margin-top: 12px;
  color: #1e40af;
  text-decoration: underline;
  text-align: center;
  font-size: 14px;
}
</style>
